import { toast } from '@webapp/components/Notification'
import { useProcurifyIntl } from '@webapp/hooks'
import { type User } from '@webapp/platform/iam/entities/User'
import messages from './messages'
import { useMutateRevokeReportAccessFromAllPrimaryCategories } from '../../models/useMutateRevokeReportAccessFromAllPrimaryCategories'

export const useRevokeReportAccessFromAllPrimaryCategoriesPresenter = () => {
  const intl = useProcurifyIntl()
  const { revokeReportAccessFromAllPrimaryCategories, isRevoking } =
    useMutateRevokeReportAccessFromAllPrimaryCategories()

  /**
   * Tenant-wide bulk revoke (BHV-025 command side). Shows the success toast;
   * the promise REJECTS on error so the Feature-Set-owned confirmation
   * handler toasts from the caught error (ADR-10). The danger dialog and
   * reset-to-ADD are Feature Set concerns.
   */
  const revokeFromAllPrimaryCategories = async (user: User): Promise<void> => {
    await revokeReportAccessFromAllPrimaryCategories({
      userAuthId: user.authId,
    })

    toast.success({
      title: intl.formatMessage(messages.successToastTitle),
      children: intl.formatMessage(messages.successToastMessage, {
        userFullName: user.fullName,
      }),
    })
  }

  return {
    commands: {
      revokeFromAllPrimaryCategories,
    },
    states: {
      isRevoking,
    },
  }
}
